// extracted by mini-css-extract-plugin
module.exports = {"box":"product-iconbox-module--box--S-ei4"};